
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hJWhT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $30e692fb0ba109f6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $30e692fb0ba109f6$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': "Vi skickar en p\xe5minnelse till alla via e-post. Det kan ta upp till en minut.",
    'people.menu.renotify.flag.description.confluence': "P\xe5minn teammedlemmar",
    'people.menu.renotify.flag.title': "Skickar p\xe5minnelser",
    'people.menu.renotify.flag.title.confluence': "Skickar e-postmeddelandet med inbjudan p\xe5 nytt",
    'people.menu.renotify.menu.description': "{userCount, plural, one {{userCount,number} person har inte accepterat sin {product}-inbjudan. Ta reda p\xe5 vem det \xe4r och skicka en p\xe5minnelse.} other {{userCount,number} personer har inte accepterat sina {product}-inbjudningar. Ta reda p\xe5 vilka det \xe4r och skicka en p\xe5minnelse.}}",
    'people.menu.renotify.menu.description.confluence': "Vissa personer har inte accepterat sin Confluence-inbjudan. Ta reda p\xe5 vilka det \xe4r och skicka en p\xe5minnelse.",
    'people.menu.renotify.menu.dismiss': "Avf\xe4rda",
    'people.menu.renotify.menu.dismiss.confluence': 'Inte nu',
    'people.menu.renotify.menu.remind': "P\xe5minn teammedlemmar",
    'people.menu.renotify.menu.remind.confluence': "P\xe5minn teammedlemmar",
    'people.menu.renotify.menu.title': "\xc4r alla med?",
    'people.menu.renotify.modal.copied': "L\xe4nken har kopierats",
    'people.menu.renotify.modal.copy': "Kopiera inbjudningsl\xe4nk",
    'people.menu.renotify.modal.description': "Vi kan skicka en p\xe5minnelse via e-post till de saknade medlemmarna eller s\xe5 kan du dela inbjudningsl\xe4nken sj\xe4lv.",
    'people.menu.renotify.modal.description.confluence': "Skicka e-postmeddelandet med inbjudan igen eller kopiera och dela via inbjudningsl\xe4nken.",
    'people.menu.renotify.modal.dismiss': 'Avbryt',
    'people.menu.renotify.modal.resend': "Skicka p\xe5minnelse",
    'people.menu.renotify.modal.resend.confluence': "Skicka inbjudan p\xe5 nytt",
    'people.menu.renotify.modal.title': "P\xe5minn saknade medlemmar",
    'people.menu.renotify.modal.title.confluence': "P\xe5minn teammedlemmar som saknas",
    'ptc.pm.collaborators.title': 'Dina medarbetare',
    'ptc.pm.error-heading': "N\xe5got har g\xe5tt fel",
    'ptc.pm.error-image-alt-text': "En trasig robot och ett antal m\xe4nniskor som f\xf6rs\xf6ker fixa den.",
    'ptc.pm.error-text': "Vi h\xe5ller koll p\xe5 dessa fel, men du f\xe5r g\xe4rna kontakta oss om det inte hj\xe4lper att uppdatera sidan",
    'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmar}}',
    'ptc.pm.people': 'Personer',
    'ptc.pm.teams': 'Team',
    'ptc.pm.view-your-profile': 'Visa din profil',
    'ptc.pm.your-teams.title': 'Dina team'
};

});


//# sourceMappingURL=sv.e1d75a38.js.map
